import apiClient from "./index";

export const boardApi = {
	// 게시판 목록 조회
	getPosts: async (page) =>{
		return await apiClient.get(`/board?page=${page}`, {
			skipAuth: true
		});
	} ,
	// 상세 페이지 조회
	getPostDetail: async (postId) =>{
		return await apiClient.get(`/board/${postId}`);
	},
	// 게시글 작성
	createPost: async (postData) => {
		return await apiClient.post('/board', postData);
	},

	// 게시글 수정
	editPost: async (postId, postData) => {
		return await apiClient.patch(`/board/${postId}`, postData);
	},

	// 게시글 삭제
	deletePost: async (postId) => {
		return await apiClient.delete(`/board/${postId}`);
	}
}